export const GET_USER_IDENTITY = 'GET_USER_IDENTITY';
export const GET_RECRUITER = 'GET_RECRUITER';
export const GET_MODULES = 'GET_MODULES';
export const GET_COMPANY = 'GET_COMPANY';

export const GET_QUOTAS = 'GET_QUOTAS';
export const GET_JOB_ROLES = 'GET_JOB_ROLES';
export const GET_HIRING_ROLES = 'GET_HIRING_ROLES';
export const GET_CANDIDATES = 'GET_CANDIDATES';

// Breadcrumbs

export const ADD_BREADCRUMBS = 'ADD_BREADCRUMBS';
export const REMOVE_BREADCRUMBS = 'REMOVE_BREADCRUMBS';

// Question ACTION TYPES
export const ADD_QUESTION = 'ADD_QUESTION';
export const REMOVE_QUESTION = 'REMOVE_QUESTION';
export const UPDATE_QUESTION = 'UPDATE_QUESTION';

export const GET_LIBRARY_PROBLEMS = 'GET_LIBRARY_PROBLEMS';
export const GET_ALL_QUESTIONS = 'GET_ALL_QUESTIONS';

export const GET_INTERVIEW_META = 'GET_INTERVIEW_META';
export const GET_INTERVIEW_DETAILS = 'GET_INTERVIEW_DETAILS';

export const GET_TECHNOLOGIES = 'GET_TECHNOLOGIES';
export const ADD_PARTICIPANT = 'ADD_PARTICIPANT';
export const GET_ALL_PARTICIPANTS = 'GET_ALL_PARTICIPANTS';

export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';

export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

export const SHOW_ACTION = 'SHOW_ACTION';
export const HIDE_ACTION = 'HIDE_ACTION';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export const SHOW_MANAGE_INTERVIEWERS_MODAL = 'SHOW_MANAGE_INTERVIEWERS_MODAL';
export const HIDE_MANAGE_INTERVIEWERS_MODAL = 'SHOW_MANAGE_INTERVIEWERS_MODAL';

// Manager interviewers
export const GET_ALL_INTERVIEWERS = 'GET_ALL_INTERVIEWERS';
export const GET_ALL_INTERVIEWERS_SUCCESS = 'GET_ALL_INTERVIEWERS_SUCCESS';

export const ADD_INTERVIEWER = 'ADD_INTERVIEWER';
export const DELETE_INTERVIEWER = 'DELETE_INTERVIEWER';

//Ai-interview
export const GET_AI_INTERVIEWS = 'GET_AI_INTERVIEWS';
export const GET_AI_INTERVIEWS_SUCCESS = 'GET_AI_INTERVIEWS_SUCCESS';
export const GET_TRY_TEST_LINK = 'GET_TRY_TEST_LINK';
export const GET_TRY_TEST_LINK_FINISHED = 'GET_TRY_TEST_LINK_FINISHED';
export const BULK_INVITE_CANDIDATES = 'BULK_INVITE_CANDIDATES';
export const BULK_INVITE_CANDIDATES_SUCCESS = 'BULK_INVITE_CANDIDATES_SUCCESS';
export const BULK_INVITE_CANDIDATES_FAILED = 'BULK_INVITE_CANDIDATES_FAILED';
export const BULK_INVITE_STATUS = 'BULK_INVITE_STATUS';
export const BULK_INVITE_STATUS_FINISH = 'BULK_INVITE_STATUS_FINISH';
export const BULK_INVITE_STATUS_FAILED = 'BULK_INVITE_STATUS_FAILED';
// Roles
export const FETCH_ROLES = 'FETCH_ROLES';
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAILURE = 'FETCH_ROLES_FAILURE';

export const CREATE_OR_UPADTE_ROLE = 'CREATE_OR_UPADTE_ROLE';
export const CREATE_OR_UPADTE_ROLE_SUCCESS = 'CREATE_OR_UPADTE_ROLE_SUCCESS';
export const CREATE_OR_UPADTE_ROLE_FAILURE = 'CREATE_OR_UPADTE_ROLE_FAILURE';
export const CHANGE_USER_ROLE = 'CHANGE_USER_ROLE';
export const CHANGE_USER_ROLE_SUCCESS = 'CHANGE_USER_ROLE_SUCCESS';
export const CHANGE_USER_ROLE_FAILURE = 'CHANGE_USER_ROLE_FAILURE';
export const DELETE_ROLE = 'DELETE_ROLE';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILURE = 'DELETE_ROLE_FAILURE';
export const RESEND_MEMBER_INVITE = 'RESEND_MEMBER_INVITE';
export const RESEND_MEMBER_INVITE_SUCCESS = 'RESEND_MEMBER_INVITE_SUCCESS';
export const RESEND_MEMBER_INVITE_FAILURE = 'RESEND_MEMBER_INVITE_FAILURE';
export const DELETE_MEMBER_INVITE = 'DELETE_MEMBER_INVITE';
export const DELETE_MEMBER_INVITE_SUCCESS = 'DELETE_MEMBER_INVITE_SUCCESS';
export const DELETE_MEMBER_INVITE_FAILURE = 'DELETE_MEMBER_INVITE_FAILURE';
export const ACTIVATE_MEMBER = 'ACTIVATE_MEMBER';

// Recruiter
export const INVITE_RECRUITER = 'INVITE_RECRUITER';
export const TOGGLE_RECRUITER_STATUS = 'TOGGLE_RECRUITER_STATUS';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';

// Backoffice
export const BO_GET_COMPANY_DETAILS_REQUEST = 'BO_GET_COMPANY_DETAILS_REQUEST';
export const BO_GET_COMPANY_DETAILS_SUCCESS = 'BO_GET_COMPANY_DETAILS_SUCCESS';
export const BO_GET_COMPANY_DETAILS_FAILURE = 'BO_GET_COMPANY_DETAILS_FAILURE';

export const BO_GET_USER_DETAILS = 'BO_GET_USER_DETAILS';
export const BO_GET_USER_DETAILS_SUCCESS = 'BO_GET_USER_DETAILS_SUCCESS';
export const BO_GET_USER_DETAILS_FAILURE = 'BO_GET_USER_DETAILS_FAILURE';

export const GET_BO_COMPANY_QUOTA_DETAILS_REQUEST =
  'GET_BO_COMPANY_QUOTA_DETAILS_REQUEST';
export const GET_BO_COMPANY_QUOTA_DETAILS_SUCCESS =
  'GET_BO_COMPANY_QUOTA_DETAILS_SUCCESS';
export const GET_BO_COMPANY_QUOTA_DETAILS_FAILURE =
  'GET_BO_COMPANY_QUOTA_DETAILS_FAILURE';

export const GET_BO_COMPANY_MONTHLY_STATS_REQUEST =
  'GET_BO_COMPANY_MONTHLY_STATS_REQUEST';
export const GET_BO_COMPANY_MONTHLY_STATS_SUCCESS =
  'GET_BO_COMPANY_MONTHLY_STATS_SUCCESS';
export const GET_BO_COMPANY_MONTHLY_STATS_FAILURE =
  'GET_BO_COMPANY_MONTHLY_STATS_FAILURE';

export const GET_BO_COMPANY_TEAM_MEMBERS_STATS_REQUEST =
  'GET_BO_COMPANY_TEAM_MEMBERS_STATS_REQUEST';
export const GET_BO_COMPANY_TEAM_MEMBERS_STATS_SUCCESS =
  'GET_BO_COMPANY_TEAM_MEMBERS_STATS_SUCCESS';
export const GET_BO_COMPANY_TEAM_MEMBERS_STATS_FAILURE =
  'GET_BO_COMPANY_TEAM_MEMBERS_STATS_FAILURE';

export const GET_COMPANY_TEAM_MEMBERS_STATS_REQUEST =
  'GET_COMPANY_TEAM_MEMBERS_STATS_REQUEST';
export const GET_COMPANY_TEAM_MEMBERS_STATS_SUCCESS =
  'GET_COMPANY_TEAM_MEMBERS_STATS_SUCCESS';
export const GET_COMPANY_TEAM_MEMBERS_STATS_FAILURE =
  'GET_BO_COMPANY_TEAM_MEMBERS_STATS_FAILURE';

export const GET_LAZY_LOGIN_TOKEN = 'GET_LAZY_LOGIN_TOKEN';
export const GET_LAZY_LOGIN_TOKEN_SUCCESS = 'GET_LAZY_LOGIN_TOKEN_SUCCESS';
export const GET_LEDGER_DETAILS_REQUEST = 'GET_LEDGER_DETAILS_REQUEST';
export const GET_LEDGER_DETAILS_SUCCESS = 'GET_LEDGER_DETAILS_SUCCESS';
export const GET_LEDGER_DETAILS_FAILURE = 'GET_LEDGER_DETAILS_FAILURE';
export const GET_BO_LEDGER_DETAILS_REQUEST = 'GET_BO_LEDGER_DETAILS_REQUEST';
export const GET_BO_LEDGER_DETAILS_SUCCESS = 'GET_BO_LEDGER_DETAILS_SUCCESS';
export const GET_BO_LEDGER_DETAILS_FAILURE = 'GET_BO_LEDGER_DETAILS_FAILURE';
export const GET_LAZY_LOGIN_TOKEN_FAILURE = 'GET_LAZY_LOGIN_TOKEN_FAILURE';
// Dhwani
export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const GET_CAMPAIGNS_WITH_DELAY = 'GET_CAMPAIGNS_WITH_DELAY';
export const GET_CAMPAIGN_DETAILS = 'GET_CAMPAIGN_DETAILS';
export const GET_CAMPAIGN_SUMMARY = 'GET_CAMPAIGN_SUMMARY';
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const GET_COCALLER_APP_SETTINGS = 'GET_COCALLER_APP_SETTINGS';

export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';
